module.exports = {"id":"209911","name":"Chisamba Lungu","rating":"73","photo":"./data/images/photos/1/209911.png","club":{"name":"Aytemiz Alanyaspor","logo":"./data/images/clubs/AytemizAlanyaspor.png"},"positions":["MG","BU","MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChisambaLungu0.json
// module id = 774
// module chunks = 0